<form>
  <div class="filter-panel">
    <div class="filter-panel-item">
      <mat-form-field>
        <input #municipalityName type="text" [placeholder]="'periods' | translate" aria-label="Name" matInput
          [formControl]="nameForm" />

        <mat-icon *ngIf="municipalityName.value.length > 0" (click)="nameForm.setValue(''); filterPeriods()" matSuffix>
          close</mat-icon>
      </mat-form-field>
    </div>

    <div class="filter-panel-item">
      <mat-form-field>
        <input (click)="pickerFrom.open()" [placeholder]="'period-from' | translate" matInput
          [matDatepicker]="pickerFrom" [formControl]="fromForm" />
        <mat-icon *ngIf="fromForm && fromForm.value && fromForm.value.length > 0"
          (click)="fromForm.setValue(''); filterPeriods()">close</mat-icon>
        <mat-datepicker-toggle matSuffix [for]="pickerFrom"></mat-datepicker-toggle>
        <mat-datepicker #pickerFrom></mat-datepicker>
      </mat-form-field>
    </div>

    <div class="filter-panel-item">
      <mat-form-field>
        <input (click)="pickerTo.open()" [placeholder]="'period-to' | translate" matInput [matDatepicker]="pickerTo"
          [formControl]="toForm" />
        <mat-icon *ngIf="toForm && toForm.value && toForm.value.length > 0"
          (click)="toForm.setValue(''); filterPeriods()" matSuffix>close</mat-icon>
        <mat-datepicker-toggle matSuffix [for]="pickerTo"></mat-datepicker-toggle>
        <mat-datepicker #pickerTo></mat-datepicker>
      </mat-form-field>
    </div>

    <div class="filter-panel-item">
      <button mat-raised-button color="primary" mat-raised-button (click)="filterPeriods()">
        <mat-icon>search</mat-icon>
        {{ "search" | translate }}
      </button>
    </div>

    <div class="filter-panel-item">
      <button *ngIf="nameForm.value || fromForm.value || toForm.value" mat-raised-button (click)="clearFilter()">
        {{ "clear" | translate }}
      </button>
    </div>
    <div class="filter-panel-item" *ngIf="isAdministrator">
      <button (click)="addPeriod()" color="primary" mat-raised-button>
        <mat-icon>add</mat-icon> {{ "add" | translate }}
      </button>
    </div>
  </div>

</form>

<table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
  <ng-container matColumnDef="description">
    <th mat-header-cell *matHeaderCellDef>
      {{ "period-description" | translate }}
    </th>
    <td mat-cell *matCellDef="let element">{{ element.description }}</td>
  </ng-container>

  <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef>{{ "periods" | translate }}</th>
    <td mat-cell *matCellDef="let element">
      <b> {{ element.name }} </b>
    </td>
  </ng-container>

  <ng-container matColumnDef="from">
    <th class="text-center" mat-header-cell *matHeaderCellDef>
      {{ "period-from" | translate }}
    </th>
    <td class="text-center" mat-cell *matCellDef="let element">
      {{ element.from | date: "dd MMM yyyy" }}
    </td>
  </ng-container>

  <ng-container matColumnDef="to">
    <th class="text-center" mat-header-cell *matHeaderCellDef>
      {{ "period-to" | translate }}
    </th>
    <td class="text-center" mat-cell *matCellDef="let element">
      {{ element.to | date: "dd MMM yyyy" }}
    </td>
  </ng-container>

  <ng-container matColumnDef="actions">
    <th mat-header-cell *matHeaderCellDef></th>
    <td mat-cell *matCellDef="let element">
      <div class="actions-panel">
        <mat-icon *ngIf="isAdministrator" (click)="editPeriod(element)" matTooltip="Edit">edit</mat-icon>
        <mat-icon *ngIf="isAdministrator" (click)="deletePeriod(element)" matTooltip="Delete">delete</mat-icon>
      </div>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
  <tr mat-row *matRowDef="let element; columns: columnsToDisplay"></tr>
</table>

<mat-paginator #paginator [length]="total" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions"
  (page)="changePage($event)">
</mat-paginator>